

















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IUser, Callback, UserRoles, IServiceDTO, ITechPrice } from "@/interfaces";
import { UpdatedUser, InsertUser, GetTechPrices, UpdatedTechPrices } from "@/api";
import {
  FIRST_NAME_VALIDATORS,
  LAST_NAME_VALIDATORS,
  EMAIL_VALIDATORS,
  INITIAL_VALIDATORS,
  PHONE_VALIDATORS,
  MOBILE_VALIDATORS,
  USERNAME_RULES,
  PASSWORD_RULES,
  REQUIRED_RULE,
  PRICE_REQ_RULES,
} from "@/validators";
import { makeUser } from "@/utils";
import { Action } from "vuex-class";
import { RimRepairRolesComponent } from "@/components/common";
import MoneyField from "../../invoices/money-field.vue";
import { UserInterface } from "@/utils/UserInterface";

@Component({
  components: {
    RimRepairRolesComponent,
    MoneyField,
  },
})
export default class UserDetailsFormComponent extends Vue {
  @Prop({ required: true }) user!: IUser;
  @Prop({ required: true }) id!: number | null;
  public buttonLoading = false;

  public userToEdit: IUser = makeUser({});
  public valid = false;

  public firstNameRules = FIRST_NAME_VALIDATORS;
  public lastNameRules = LAST_NAME_VALIDATORS;
  public initialRules = INITIAL_VALIDATORS;
  public emailRules = EMAIL_VALIDATORS;
  public phoneRules = PHONE_VALIDATORS;
  public mobileRules = MOBILE_VALIDATORS;
  public userNameRules = USERNAME_RULES;
  public passRules = PASSWORD_RULES;
  public showPass: boolean = false;
  public serviceItems: IServiceDTO[] = [];
	public techPrices: ITechPrice[] = [];

  public req = REQUIRED_RULE;
  public priceRules = PRICE_REQ_RULES;

  private UI__: UserInterface;
	
  mounted() {
    this.UI__ = new UserInterface(this);
    this.serviceItems = this.$store.getters["AppModule/serviceItems"];
  }

  @Watch("user", { immediate: true })
  public setUserToEdit() {
		if (!this.user.RecordID)return;
    this.userToEdit = { ...this.user };
		this.GetTechPrices();
  }

	async GetTechPrices(){
    // this.UI__.TurnBlockerOn();
		var techPrices = await GetTechPrices(this.userToEdit.RecordID);
		if (techPrices.Ok){
			this.techPrices = techPrices.TechPrices;
		}
    // this.UI__.TurnBlockerOff();
	}


  async validate() {
    if (!(this.$refs.userDetailsForm as HTMLFormElement).validate()) return;

    this.buttonLoading = true;
    let resp;

    this.UI__.TurnBlockerOn();

		/// UPDATING THE TECHPRICES, ALONGSIDE THE TECH INFORMATION ITSELF.
		UpdatedTechPrices(this.userToEdit.RecordID, this.techPrices);

    resp = this.id
      ? await UpdatedUser(this.userToEdit)
      : await InsertUser(this.userToEdit);


    this.buttonLoading = false;
    this.UI__.TurnBlockerOff();


    if (resp.Ok) {

			this.UI__.IntakeStaffStatusChange(resp.User);

      this.$router.push("/users");

      this.UI__.SnacSuccess(
        `User ${this.id ? "Updated" : "Inserted"} Successfully !`
      );

			/// WILL DISPATCH A NOTIFICATION,
			/// SO COMPONENTS SHOWING USERS WILL REFRESH
			/// TO SHOW UPDATED DATA.
			this.UI__.RefreshTimestampUsers();

    }
  }

  cancel() {
    this.$router.push("/users");
  }

  // addRole(role: UserRoles) {
  //   this.$emit("addRole", role);
  // }

  // removeRole(role: UserRoles) {
  //   this.$emit("removeRole", role);
  // }

  get buttonLabel() {
    return this.id ? "Update User" : "Insert User";
  }
}
